// The card's aggregator: the period's scanned games whose middlegame went
// wrong (middlegame result Blown advantage or Behind), by why
// (`GameFacts.groundCause`: Tactic, Missed chance, Time, Positional — the
// cause that cost the most win chance over the whole middlegame, from
// `@chess/api-mistakes`' `lostGroundCause`). Games that went wrong with no
// counted mistake have no cause and are counted apart. Registered with the
// game store by this plugin's setup; the store runs it over the last 30 days'
// games on every change and keeps the result.
import { aggregatorId, GROUND_CAUSES, type Accumulator, type Aggregator, type GroundCause } from '@chess/api-model';

/** What the card shows; plain data, so the card and its stories need no store. */
export interface LostGroundResult {
  /** Games in each cause; they add up to the middlegames shown. */
  byCause: Record<GroundCause, number>;
  /** Middlegames that went wrong without a counted mistake: not in the pie. */
  uncaused: number;
}

export class LostGroundAggregator implements Aggregator<LostGroundResult> {
  readonly id = aggregatorId('lost-ground');

  start(): Accumulator<LostGroundResult> {
    const byCause: Record<GroundCause, number> = { tactic: 0, missed: 0, time: 0, positional: 0 };
    let uncaused = 0;
    return {
      add: (game) => {
        if (!game.scanned || (game.middlegameResult !== 'blown' && game.middlegameResult !== 'behind')) return;
        if (game.groundCause) byCause[game.groundCause] += 1;
        else uncaused += 1;
      },
      result: () => ({ byCause, uncaused }),
    };
  }
}

/** The middlegames in the pie: every cause together. */
export const wentWrongOf = (r: LostGroundResult) => GROUND_CAUSES.reduce((sum, c) => sum + r.byCause[c], 0);
